var React = require('react');

function AdsIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"29.5","cy":"40.5","r":"29.5","fill":"#67DFC3","key":0}),React.createElement("path",{"d":"M70 40C70 17.9086 52.0914 0 30 0V40H70Z","fill":"#4A91FB","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M58.9958 39.9958C58.7317 24.1004 45.8954 11.2642 30 11V39.9958H58.9958Z","fill":"#285ECD","key":2})]);
}

AdsIcon.defaultProps = {"width":"28","height":"28","viewBox":"0 0 70 70","fill":"none"};

module.exports = AdsIcon;

AdsIcon.default = AdsIcon;
